import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFavoriteItem',
  props: {
  favorite: {
    type: Object as PropType<CollectionItem>,
    default: undefined
  },
  small: {
    type: Boolean,
    default: false
  },
  knockout: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {




const collections = useCollectionsStore()
// Use the given favorite or the page favorite
const localFavorite = computed(() => __props.favorite || useUiStore().pageFavorite)

const isFavorite = computed(() => collections.isFavorite(localFavorite.value))
const saving = ref(false)

const size = computed(() => __props.small ? 'small' : undefined)
const color = computed(() => __props.knockout ? 'white' : 'primary' )
const icon = computed(() => useIconLib(
  saving.value ? 'Spinner' :  (
    isFavorite.value ? 'Favorited' : 'Favorite')
))

function handleFavorite() {
  // No double-clicking
  if (saving.value) return

  // Set saving flag
  saving.value = true
  // Call appropriate method
  const method = isFavorite.value ? collections.removeFavorite : collections.addFavorite
  method(localFavorite.value)
    .catch((_error) => Notify.error('Error saving favorite'))
    .finally(() => saving.value = false)
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, { bottom: "" }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps(props, {
        variant: "plain",
        size: _unref(size),
        color: _unref(color),
        icon: _unref(icon),
        class: { 'hy-spin': _unref(saving) },
        onClick: _withModifiers(handleFavorite, ["stop","prevent"])
      }), null, 16, ["size", "color", "icon", "class"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_unref(isFavorite) ? 'Remove from favorites' : 'Add to favorites'), 1)
    ]),
    _: 1
  }))
}
}

})